import { gql } from '@apollo/client'

export const GET_USER_PROFILE = gql`
    query GetUserProfile($id: ID!) {
        getUserProfile(id: $id) {
            id
            email
            firstName
            lastName
            phone
            dateOfBirth
            notifyEmail
            notifyPhone
            availableRoles
            activeRole
            payableAddress
            loanApplication {
                id
                state
                owner
                updatedOn
                userProfileId
                createdOn
            }
            loanApplicationId
            countryId
            country {
                id
                name
                abbreviation
                _version
                _deleted
                _lastChangedAt
                createdOn
                updatedOn
                owner
            }
            lastLoginDate
            _version
            _deleted
            _lastChangedAt
            createdOn
            updatedOn
            interests {
                items {
                    id
                    userProfileId
                    productInterestId
                    createdOn
                    updatedOn
                    owner
                }
                nextToken
                startedAt
            }
        }
    }
`
